import { convertToPt } from '../../extension-word/utils';
import { findParentNodeClosestToPos, type KeyboardShortcutCommand } from '@tiptap/core';
import { Node as ProseMirrorNode } from '@tiptap/pm/model';

import { isCellSelection } from './tableUtils';

// 테이블 생성
export function createTable(editor, rows, cols): ProseMirrorNode {
    if (rows < 1 || cols < 1) {
        throw new Error('rows와 cols는 1 이상이어야 합니다.');
    }

    const { $anchor } = editor.state.selection;

    // 현재 커서가 위치한 가장 가까운 블록 요소 찾기
    const domAtPos = editor.view.domAtPos($anchor.pos);
    const nodeDOM = domAtPos.node.nodeType === 3 ? domAtPos.node.parentElement : domAtPos.node;

    // 블록 요소의 현재 width
    const blockWidth = nodeDOM.clientWidth;

    // 각 셀의 너비를 계산하여 colwidth에 적용 (px 기준)
    const colWidthPx = blockWidth / cols;
    const colWidthPt = convertToPt(colWidthPx + 'px');

    const rowsNodes: unknown[] = [];

    for (let r = 0; r < rows; r++) {
        const cells: unknown[] = [];
        for (let c = 0; c < cols; c++) {
            cells.push(
                editor.schema.nodes.tableCell.createAndFill({
                    width: colWidthPt + 'pt',
                    borders: {
                        bottom: { isVisible: true, lineWidth: 0.5, color: 'black' },
                        left: { isVisible: true, lineWidth: 0.5, color: 'black' },
                        right: { isVisible: true, lineWidth: 0.5, color: 'black' },
                        top: { isVisible: true, lineWidth: 0.5, color: 'black' },
                    },
                }),
            );
        }
        rowsNodes.push(editor.schema.nodes.tableRow.createAndFill(null, cells));
    }

    return editor.schema.nodes.table.createAndFill(null, rowsNodes);
}

export const deleteTableWhenAllCellsSelected: KeyboardShortcutCommand = ({ editor }) => {
    const { selection } = editor.state;

    if (!isCellSelection(selection)) {
        return false;
    }

    let cellCount = 0;
    const table = findParentNodeClosestToPos(selection.ranges[0].$from, node => {
        return node.type.name === 'table';
    });

    table?.node.descendants(node => {
        if (node.type.name === 'table') {
            return false;
        }

        if (['tableCell'].includes(node.type.name)) {
            cellCount += 1;
        }
    });

    const allCellsSelected = cellCount === selection.ranges.length;

    if (!allCellsSelected) {
        return false;
    }

    editor.commands.deleteTable();

    return true;
};
